import React from "react";
import logo from "../assets/logo.png";
import { Link, Navigate, useNavigate } from 'react-router-dom';

export class Navbar extends React.Component{
    constructor(){
        super();
    }
    render(){
        return (
            <div className="navbar-block">
                <div className="navbar-container">
                    <div className="navbar-logo-container">
                        <Link to="" className="navbar-logo">
                            <img src={logo} className="navbar-logo-img"></img>
                        </Link>
                    </div>
                    <ul className="navbar-link-container">
                        <Link className="navbar-link" to="/">Home</Link>
                        <Link className="navbar-link" to="/learn">Learn</Link>
                        <Link className="navbar-link" to="/download">Download</Link>
                    </ul>
                    <div className="navbar-extra-container">
                        {/* <a className="navbar-extra-item">☰</a> */}
                        {/* <a className="navbar-extra-item">語言</a> */}
                    </div>
                </div>
            </div>
        )
    }
}